import { Const } from '../lib/const.cls'

export const mutations = {
    [Const.SET_PROFILE_INFO](state, data) {
        try { state.profileInfo = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_PAYMENT_METHODS](state, data) {
        try { state.GetPaymentMethods = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_TRADING_ACCOUNT](state, data) {
        try { state.tradingAccount = data } catch (ex) { console.debug('set state EX', ex) }
    },


    [Const.SET_NEWS_DATA](state, data) {
        try { state.newsData = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_ECONOMIC_CALENDER_DATA](state, data) {
        try { state.economicCalData = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_OPEN_TRADE](state, data) {
        try { state.openTradeList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_PENDING_ORDER](state, data) {
        try { state.pendingOrderList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_TRADE_HISTORY](state, data) {
        try { state.tradeHistoryList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_TRANSACTION_HISTORY](state, data) {
        try { state.transactionHistory = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_ACCOUNT_BALANCE](state, data) {
        try { state.accBalance = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_REJECTED_TRADE](state, data) {
        try { state.rejectedTradeList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_PENDING_TRADE](state, data) {
        try { state.pendingTradeList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_WS_ORDER](state, data) {
        try { state.wsOrder = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_CURRENCY_PAIRS](state, data) {
        try { state.currencyPairs = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_PRICE_SHIFT](state, data) {
        try { state.priceShift = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_WATCH_LIST](state, data) {
        try { state.watchList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_ORDER_BOOK](state, data) {
        try { state.orderBook = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_PROVIDER_LIST](state, data) {
        try { state.providerList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_USER_ACCOUNTS](state, data) {
        try { state.accountList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_USER_PROFILE](state, data) {
        try { state.profileData = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_WS_STATUS](state, data) {
        try { state.wsStatus = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_USER_SETTINGS](state, data) {
        try { state.userSettings = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_ACTIVE_PRICE_ALERT](state, data) {
        try { state.activePriceAlert = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_TRIGGERED_PRICE_ALERT](state, data) {
        try { state.triggeredPriceAlert = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_PRICE_ALERT_NOTIFICATON](state, data) {
        try { state.priceAlertNotification = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_PORTFOLIO](state, data) {
        try { state.portfolioData = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_RAW_OBJECT](state, data) {
        try { state.rawObject = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_APP_THEME](state, data) {
        try { state.appTheme = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_APP_CHART](state, data) {
        try { state.chartCompany = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_TECHNICAL_ANALYSIS](state, data) {
        try { state.technicalAnalysis = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_PIVOT_DATA](state, data) {
        try { state.pivotData = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_LEADERS_LIST](state, data) {
        try { state.leadersList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_ALL_LEADERS_LIST](state, data) {
        try { state.allLeadersList = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_LEADER_DETAIL](state, data) {
        try { state.leaderDetail = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_PROFIT_CHART_DATA] (state, data) {
		try {state.profitChartData = data} catch (ex) {console.debug('set state EX', ex)}
	},

	[Const.SET_PERFORMANCE_CHART_DATA] (state, data) {
		try {state.performanceChartData = data} catch (ex) {console.debug('set state EX', ex)}
	},

	[Const.SET_PORTFOLIO_CHART_DATA] (state, data) {
		try {state.portfolioChartData = data} catch (ex) {console.debug('set state EX', ex)}
	},
	[Const.SET_DRAWDOWN_CHART_DATA] (state, data) {
		try {state.drawdownChartData = data} catch (ex) {console.debug('set state EX', ex)}
	},
	[Const.SET_LEADER_TRADE_HISTORY] (state, data) {
		try {state.leaderTradeHistory = data} catch (ex) {console.debug('set state EX', ex)}
	},
    [Const.SET_FOLLOWERS_SETTING](state, data) {
        try { state.followersSetting = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_USER_EQUITY_CHART_WITH_LEADER](state, data) {
        try { state.userEquityChartWithLeader = data } catch (ex) { console.debug('set state EX', ex) }
    },
    [Const.SET_USER_COPYTRADING_TOKEN](state, data) {
        try { state.userCopytradingDetails = data } catch (ex) { console.debug('set state EX', ex) }
    },
}


// WEBPACK FOOTER //
// ./src/plugins/commonAll/provider/store-addons/mutations.js